export const LOGIN_OTP = "api/login";
export const SEARCH_REFILL = "api/get/details";
export const GENERATE_OTP = "api/signup";
export const UPDATE_REFILL_STATUS = "api/update/status";
export const MEDICINE_LIST = "/api/get/medicines";